import { Banner, SimpleModal, Box } from '@sequencehq/core-components'
import { FC } from 'react'

export const MarkAsPrimaryBillingContactDialog: FC<{
  title: string
  isOpen: boolean
  onClose: () => void
  onConfirm: () => Promise<void>
}> = ({ title, isOpen, onClose, onConfirm }) => {
  return (
    <SimpleModal
      data-testid="contacts.markPrimaryDialog"
      variant="dialog"
      disableSubmitOnEnter
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      cancelButtonText="Cancel"
      submitButtonText="Continue"
      onSubmit={async () => {
        await onConfirm()
        return true
      }}
    >
      <Box mb={4}>
        A primary contact is required for integrations and payment gateways that
        only accept a single email per customer.
      </Box>
      <Banner variant="neutral">
        Sequence will use this email address when linking this customer to a
        third party integration.
      </Banner>
    </SimpleModal>
  )
}
